import { Injectable, inject } from '@angular/core';
import { fromEvent, Observable, Subscription, switchMap } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { UIConfirmationDialogService } from '@vdms-hq/ui';

@Injectable({ providedIn: 'root' })
export class StorageHandlerService {
  private readonly confirmationDialogService = inject(UIConfirmationDialogService);

  #storageCleanListener: Observable<unknown> = fromEvent(window, 'storage').pipe(
    filter(({ key }: StorageEvent) => key === null),
    switchMap(() => {
      return this.confirmationDialogService.open({
        title: 'Storage has been cleared',
        message: 'Browser local storage has been cleared - the page will be refreshed.',
        okAction: {
          label: 'ok',
          color: 'primary',
        },
        abortAction: null,
      });
    }),
    tap(async () => {
      window.location.reload();
    }),
  );
  #listeners?: Subscription;

  registerListeners(): void {
    if (this.#listeners) {
      return;
    }

    this.#listeners = this.#storageCleanListener.subscribe();
  }
}
